const styles = {
  "elevation-0": "_elevation-0_r47ki_1",
  "elevation-1": "_elevation-1_r47ki_5",
  "elevation-2": "_elevation-2_r47ki_9",
  "elevation-3": "_elevation-3_r47ki_13",
  "elevation-4": "_elevation-4_r47ki_17",
  "elevation-6": "_elevation-6_r47ki_21",
  "elevation-8": "_elevation-8_r47ki_25"
};
export {
  styles as default
};
//# sourceMappingURL=Card.module.scss.js.map
